import {
  call, put, select, takeLatest, takeEvery, all,
} from 'redux-saga/effects';
import callAdapter, { callAdapterResponseError } from '@/utils/sagaHelper';
import findResult, { successAndErrors, wildcardFilter } from '@/utils/resultsHelper';
import selectors from '@/selectors';
import { CARDS_PAGE_SIZE, presentationOptions } from '@/constants/states';
import ThemeService from '../service';
import {
  showThemes,
  showThemesError,
  editTheme,
  editThemeError,
  editThemeEnabledError,
  applyTheme,
  chooseThemeError,
  editThemeEnabled,
  showImageSuccess,
  showImageError,
} from '../actions';
import actions, { imageActions, themeLists } from '../constants';

export function* themes(action) {
  const items = yield select(selectors.themes);
  const {
    display, filter, pageSize, currentPage, params,
  } = items[action.category];
  const page = action.page || currentPage;
  const size = action.pageSize || pageSize;
  const { response, error } = yield call(callAdapter, ThemeService.themes(
    wildcardFilter(filter),
    page,
    display === presentationOptions.CARDS ? CARDS_PAGE_SIZE : size,
    params,
  ));

  if (error) {
    yield put(showThemesError(action.category, error));
  } else {
    yield put(showThemes(
      action.category,
      action.append,
      size,
      response.items,
      response.paging.total,
      response.paging.pages,
      response.paging.page,
    ));
  }
}

export function* update() {
  const item = yield select(selectors.activeTheme);
  const { response, error } = yield call(callAdapter, ThemeService.update(item));
  if (error) {
    yield put(editThemeError(error));
  } else {
    yield put(editTheme(response.code, response));
    yield all(themeLists.map((category) => themes({ category })));
  }
}

export function* updateEnabled({ category, code, name }) {
  const items = yield select(selectors.themes);
  const { enabled } = findResult(items, category, code);
  const { response, error } = yield call(callAdapter, ThemeService.updateEnabled(code, !enabled));
  if (error) {
    yield put(editThemeEnabledError(code, category, name, error));
  } else {
    yield put(editThemeEnabled(response.code, category, response));
    yield all(themeLists.map((c) => themes({ category: c })));
  }
}

export function* chooseTheme({ code, name }) {
  const { error } = yield call(callAdapter, ThemeService.apply(code));
  if (error) {
    yield put(chooseThemeError(code, name, error));
  } else {
    yield put(applyTheme({ code }));
  }
}

export function* images({ items }) {
  const results = yield all(items.map((i) => callAdapterResponseError(i, ThemeService.image(i.code))));
  const { success, errors } = successAndErrors(results);

  if (errors.length > 0) {
    yield put(showImageError(errors));
  }
  if (success.length > 0) {
    yield put(showImageSuccess(success));
  }
}

export function* refreshThemesPresentation(action) {
  yield call(themes, { ...action, page: 1, append: false });
}

export default function* themesApi() {
  yield takeEvery([actions.FETCH_THEMES, actions.REFRESH_THEMES], themes);
  yield takeLatest(actions.UPDATE_THEME, update);
  yield takeEvery(actions.UPDATE_THEME_ENABLED, updateEnabled);
  yield takeEvery(actions.CHOOSE_THEME, chooseTheme);
  yield takeEvery(imageActions.FETCH_IMAGES, images);
  yield takeEvery(actions.TOGGLE_THEMES_PRESENTATION, refreshThemesPresentation);
}
